import { createAction } from '@reduxjs/toolkit';

import { type IGetLicensesParams } from '../../Licenses/services/licensesApiService';

export const getChildren = createAction<IGetLicensesParams>('getChildren');
